import type { AdaptationView, CanonicalPeriod, EmissionTier } from '../common'
import PortfolioExtremeWind from './PortfolioExtremeWind'

type PortfolioWindGustProps = {
  emissionTier: EmissionTier
  selectedPeriod: CanonicalPeriod
  view?: AdaptationView
}

export default function PortfolioWindGust(props: PortfolioWindGustProps) {
  return <PortfolioExtremeWind {...props} hazardCode="wind_gust" />
}
